var _defs, _path, _path2, _rect, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 38,
    viewBox: "0 0 106 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #11142d;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fb9678;\n        stroke:#fb9678;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 1px;\n      }\n\n      .cls-3 {\n        fill: #03c9d7;\n        stroke: #03c9d7;\n      }\n\n      .cls-4 {\n        fill: #fec90f;\n        stroke: #fec90f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Flexy",
    className: "cls-1",
    d: "M47.2,26.75v-7.2h6.288V17.126H47.2v-4.7H54.98V9.95H44.132v16.8H47.2Zm12.928,0V9.47H57.06V26.75h3.072Zm11.292-.24a5.5,5.5,0,0,0,1.92-1.452,5.659,5.659,0,0,0,1.116-2.052H71.34a2.6,2.6,0,0,1-.948,1.092,2.791,2.791,0,0,1-1.572.42,3.054,3.054,0,0,1-2.124-.792,3.1,3.1,0,0,1-.972-2.184h9.048q0.024-.312.036-0.6t0.012-.552a5.9,5.9,0,0,0-.756-2.964,5.518,5.518,0,0,0-2.1-2.1,6.132,6.132,0,0,0-3.1-.768,6.346,6.346,0,0,0-3.252.8,5.66,5.66,0,0,0-2.16,2.244,6.792,6.792,0,0,0-.78,3.288,6.388,6.388,0,0,0,.792,3.216,5.557,5.557,0,0,0,2.184,2.16,6.5,6.5,0,0,0,3.192.768A6.075,6.075,0,0,0,71.424,26.51Zm-0.588-8.76a2.592,2.592,0,0,1,.864,1.872H65.772a2.947,2.947,0,0,1,1.1-1.932,3.272,3.272,0,0,1,1.992-.636A2.875,2.875,0,0,1,70.836,17.75Zm8.384,9,3.024-4.224,3,4.224h3.312L84.212,20.8l4.344-5.952H85.244l-3,4.224L79.22,14.846H75.932l4.32,5.952-4.32,5.952H79.22Zm15.592,5.28,7.56-17.184H99.108l-3.48,8.376-3.336-8.376H88.956l4.632,11.112h0.72l-2.76,6.072h3.264Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_698",
    "data-name": "Rounded Rectangle 698",
    className: "cls-2",
    d: "M8.723,4.086a5.9,5.9,0,0,1,5.895,5.895V28.216a5.895,5.895,0,1,1-11.79,0V9.981A5.9,5.9,0,0,1,8.723,4.086Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_699",
    "data-name": "Rounded Rectangle 699",
    className: "cls-3",
    x: 3,
    y: 3,
    width: 25,
    height: 12,
    rx: 6,
    ry: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 21.703,
    cy: 23.969,
    r: 6.328
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.0c9549ae.svg";
export { ForwardRef as ReactComponent };